var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShieldError(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3164 13.7313C11.075 14.6944 9.59397 15.4915 8.30273 15.9481C8.10659 16.0174 7.89341 16.0174 7.69727 15.9481C6.40503 15.4912 4.92165 14.6944 3.67969 13.7303L7.99805 9.41297L12.3164 13.7313Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9551 2.45496C14.9829 2.55042 15 2.64939 15 2.74988V9.74988C15 10.6253 14.5242 11.5258 13.7842 12.371L9.41211 7.9989L14.9551 2.45496Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58398 7.9989L2.21289 12.369C1.47411 11.5246 1.00002 10.6245 1 9.74988V2.74988C1.00001 2.65052 1.0157 2.55237 1.04297 2.45789L6.58398 7.9989Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71582 0.0418721C7.90136 -0.0134691 8.09864 -0.0134691 8.28418 0.0418721L13.1543 1.42761L7.99805 6.58484L2.8418 1.42859L7.71582 0.0418721Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldError);
export default __webpack_public_path__ + "static/media/shield-error.c16d2ad12f39ace28379e7efc09b5312.svg";
export { ForwardRef as ReactComponent };